export default "__VITE_ASSET__Cyipa3n8__"